var map = {
	"./ADA.svg": 818,
	"./BCH.svg": 819,
	"./BNB.svg": 820,
	"./BTC.svg": 821,
	"./CHZ.svg": 822,
	"./DASH.svg": 823,
	"./DOGE.svg": 824,
	"./DOT.svg": 825,
	"./ETC.svg": 826,
	"./ETH.svg": 827,
	"./EUR.svg": 828,
	"./GBP.svg": 829,
	"./LINK.svg": 830,
	"./LTC.svg": 831,
	"./MATIC.svg": 832,
	"./MKR.svg": 833,
	"./SHIB.svg": 834,
	"./SOL.svg": 835,
	"./TRX.svg": 836,
	"./UNI.svg": 837,
	"./USD.svg": 838,
	"./USDT.svg": 839,
	"./XLM.svg": 840,
	"./XMR.svg": 841,
	"./XRP.svg": 842,
	"./documents.svg": 843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 817;